import { components } from "react-select";
const CustomOption = (props) => {
  const { data } = props;
  const { inputValue } = props.selectProps;

   const highlightText = (text, highlight) => {
  if (!highlight) return text;

  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <span key={index} style={{ backgroundColor: "#ffe58f", fontWeight: "600" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};
  return (
    <components.Option {...props}>
      {highlightText(data.label, inputValue)}
    </components.Option>
  );
};
export default CustomOption;